export const VERSIONS_AUDIT_TAB = {
  MOST_RECENT_LABEL: { key: 'MOST_RECENT_LABEL', value: 'Most recent' },
  OLDEST_LABEL: { key: 'OLDEST_LABEL', value: 'Oldest' },
  LOADING_LABEL: { key: 'LOADING_LABEL', value: 'Loading...' },
  BY_LABEL: { key: 'BY_LABEL', value: 'By' },
  ON_LABEL: { key: 'ON_LABEL', value: 'on' },
  COMMENTS_LABEL: { key: 'COMMENTS_LABEL', value: 'Comments:' },
  STATUS_PUBLISHED: { key: 'STATUS_PUBLISHED', value: 'Published' },
  STATUS_SENT_FOR_APPROVAL: { key: 'STATUS_SENT_FOR_APPROVAL', value: 'Sent for approval' },
  STATUS_SENT_FOR_TESTING: { key: 'STATUS_SENT_FOR_TESTING', value: 'Sent for testing' },
  STATUS_REJECTED: { key: 'STATUS_REJECTED', value: 'Rejected' },
  AUDIT_FETCH_FAIL: { key: 'AUDIT_FETCH_FAIL', value: 'Failed to fetch Audit details' },
  TEMPLATE_NOT_MOVED: { key: 'TEMPLATE_NOT_MOVED', value: 'The template is not moved to qa and published stages' },
  TEMPLATE_AUDIT_NOT_AVAILABLE: { key: 'AUDIT_INFO_NOT_AVAILABLE', value: 'Audit history will be available once the template reaches the Testing or Published stages' },
  AUDIT_INFO_NOT_AVAILABLE: { key: 'AUDIT_INFO_NOT_AVAILABLE', value: 'Audit info not available' }
};

export const TAG_SETTINGS = {
  TAGS_TITLE: { key: 'TAGS_TITLE', value: 'Tags' },
  CREATE_NEW_TAG_TOOLTIP: { key: 'CREATE_NEW_TAG_TOOLTIP', value: 'Create new tag' },
  NO_TAGS_AVAILABLE_MESSAGE: { key: 'NO_TAGS_AVAILABLE_MESSAGE', value: 'No tags available' },
  CREATED_BY_TEXT: { key: 'CREATED_BY', value: 'Created by' },
  DELETION_CONFIRMATION: {
    key: 'DELETION_CONFIRMATION',
    value: 'Are you sure you want to delete this tag?',
  },
  DELETE_BUTTON: { key: 'DELETE_BUTTON', value: 'Delete' },
  CANCEL_BUTTON: { key: 'CANCEL_BUTTON', value: 'Cancel' },
  VERSION_DRAFT: { key: 'VERSION_DRAFT', value: 'Draft' },
  VERSION_TESTING: { key: 'VERSION_TESTING', value: 'Testing' },
  VERSION_PUBLISHED: { key: 'VERSION_PUBLISHED', value: 'Published' },
  TAGS_FETCH_FAILED_ERROR: {
    key: 'TAGS_FETCH_FAILED_ERROR',
    value: 'Failed to fetch version tags list',
  },
  TAG_DELETION_FAILED_ERROR: {
    key: 'TAG_DELETION_FAILED_ERROR',
    value: 'Failed to delete tag',
  },
};

export const ADD_TAG_FORM = {
  CREATE_NEW_TAG_TITLE: { key: 'CREATE_NEW_TAG_TITLE', value: 'Create new tag' },
  VERSION_LABEL: { key: 'VERSION_LABEL', value: 'Version' },
  TAG_NAME_LABEL: { key: 'TAG_NAME_LABEL', value: 'Tag Name' },
  VERSION_DRAFT: { key: 'VERSION_DRAFT', value: 'Draft' },
  VERSION_TESTING: { key: 'VERSION_TESTING', value: 'Testing' },
  VERSION_PUBLISHED: { key: 'VERSION_PUBLISHED', value: 'Published' },
  TAG_NAME_PLACEHOLDER: { key: 'TAG_NAME_PLACEHOLDER', value: 'Enter tag name' },
  TAG_NAME_EMPTY_ERROR: { key: 'TAG_NAME_EMPTY_ERROR', value: 'Please enter tag name.' },
  CREATE_BUTTON: { key: 'CREATE_BUTTON', value: 'Create' },
  TAG_CREATION_FAILED_ERROR: {
    key: 'TAG_CREATION_FAILED_ERROR',
    value: 'Failed to create version tag',
  },
  TAG_EXISTS_ERROR_MESSAGE: {
    key: 'TAG_EXISTS_ERROR_MESSAGE',
    value:
      'This tag name already exists in the selected environment. Enter a unique tag name.',
  },
};

export const VERSION_TOGGLE_ICON = {
  VERSIONS_TOOLTIP: { key: 'VERSIONS_TOOLTIP', value: 'Versions' },
};

export const VERSION_SETTINGS_SIDEBAR = {
  VERSIONS_TAB: { key: 'VERSIONS_TAB', value: 'Versions' },
  AUDIT_TAB: { key: 'AUDIT_TAB', value: 'Audit' },
};